import { useEffect, useRef } from 'react';

const LAND_DOTS = (() => {
  const dots = [];
  for (let la = 15; la <= 70; la += 2.2) for (let ln = -168; ln <= -52; ln += 2.2) {
    if (la > 60 && (ln < -140 || ln > -60)) continue;
    if (la > 55 && ln > -55) continue;
    if (la < 25 && ln < -90) continue;
    if (la < 20 && ln > -80) continue;
    if (Math.random() < 0.35) dots.push([la + (Math.random()-0.5)*1.2, ln + (Math.random()-0.5)*1.2]);
  }
  for (let la = -55; la <= 12; la += 2.2) for (let ln = -82; ln <= -34; ln += 2.2) {
    if (la < -20 && ln < -70) continue;
    if (la < -45 && ln > -65) continue;
    if (la > 0 && (ln < -78 || ln > -50)) continue;
    if (Math.random() < 0.35) dots.push([la + (Math.random()-0.5)*1.2, ln + (Math.random()-0.5)*1.2]);
  }
  for (let la = 36; la <= 70; la += 2.2) for (let ln = -10; ln <= 40; ln += 2.2) {
    if (la > 60 && ln > 30) continue;
    if (la < 40 && (ln < -5 || ln > 30)) continue;
    if (Math.random() < 0.4) dots.push([la + (Math.random()-0.5)*1.2, ln + (Math.random()-0.5)*1.2]);
  }
  for (let la = -34; la <= 37; la += 2.2) for (let ln = -18; ln <= 52; ln += 2.2) {
    if (la > 20 && ln > 42) continue;
    if (la < -20 && ln < 15) continue;
    if (la < -25 && ln > 35) continue;
    if (Math.random() < 0.4) dots.push([la + (Math.random()-0.5)*1.2, ln + (Math.random()-0.5)*1.2]);
  }
  for (let la = 5; la <= 72; la += 2.2) for (let ln = 40; ln <= 145; ln += 2.2) {
    if (la > 55 && ln > 135) continue;
    if (la < 15 && (ln < 100 || ln > 120)) continue;
    if (la < 10 && ln > 105) continue;
    if (la > 65 && ln < 60) continue;
    if (Math.random() < 0.38) dots.push([la + (Math.random()-0.5)*1.2, ln + (Math.random()-0.5)*1.2]);
  }
  for (let la = -8; la <= 20; la += 2.2) for (let ln = 95; ln <= 142; ln += 2.2) {
    if (Math.random() < 0.22) dots.push([la + (Math.random()-0.5)*1.2, ln + (Math.random()-0.5)*1.2]);
  }
  for (let la = -38; la <= -15; la += 2.2) for (let ln = 114; ln <= 154; ln += 2.2) {
    if (la < -32 && (ln < 116 || ln > 150)) continue;
    if (la > -20 && (ln < 130 || ln > 145)) continue;
    if (Math.random() < 0.45) dots.push([la + (Math.random()-0.5)*1.2, ln + (Math.random()-0.5)*1.2]);
  }
  for (let la = -46; la <= -34; la += 2.5) for (let ln = 166; ln <= 178; ln += 2.5) {
    if (Math.random() < 0.45) dots.push([la, ln]);
  }
  for (let la = 60; la <= 83; la += 2.5) for (let ln = -56; ln <= -18; ln += 2.5) {
    if (la < 68 && ln < -50) continue;
    if (Math.random() < 0.35) dots.push([la, ln]);
  }
  return dots;
})();

// showLabel: whether to show the name tag
// labelOffsetX/Y: custom pixel nudge for label position
const CITIES = [
  { id: 'london',     lat: 51.5,   lng: -0.1,    label: 'London',        showLabel: true,  labelSide: 'left'  },
  { id: 'manchester', lat: 53.5,   lng: -2.2,    label: 'Manchester',    showLabel: false },
  { id: 'dublin',     lat: 53.3,   lng: -6.3,    label: 'Dublin',        showLabel: false },
  { id: 'paris',      lat: 48.9,   lng: 2.4,     label: 'Paris',         showLabel: true,  labelSide: 'right' },
  { id: 'amsterdam',  lat: 52.4,   lng: 4.9,     label: 'Amsterdam',     showLabel: true,  labelSide: 'right' },
  { id: 'frankfurt',  lat: 50.1,   lng: 8.7,     label: 'Frankfurt',     showLabel: true,  labelSide: 'right' },
  { id: 'zurich',     lat: 47.4,   lng: 8.5,     label: 'Zurich',        showLabel: false },
  { id: 'geneva',     lat: 46.2,   lng: 6.1,     label: 'Geneva',        showLabel: false },
  { id: 'munich',     lat: 48.1,   lng: 11.6,    label: 'Munich',        showLabel: false },
  { id: 'madrid',     lat: 40.4,   lng: -3.7,    label: 'Madrid',        showLabel: false },
  { id: 'barcelona',  lat: 41.4,   lng: 2.2,     label: 'Barcelona',     showLabel: false },
  { id: 'milan',      lat: 45.5,   lng: 9.2,     label: 'Milan',         showLabel: false },
  { id: 'stockholm',  lat: 59.3,   lng: 18.1,    label: 'Stockholm',     showLabel: false },
  { id: 'warsaw',     lat: 52.2,   lng: 21.0,    label: 'Warsaw',        showLabel: false },
  { id: 'kyiv',       lat: 50.5,   lng: 30.5,    label: 'Kyiv',          showLabel: true,  labelSide: 'right' },
  { id: 'nyc',        lat: 40.7,   lng: -74.0,   label: 'New York',      showLabel: true,  labelSide: 'left'  },
  { id: 'boston',     lat: 42.4,   lng: -71.1,   label: 'Boston',        showLabel: false },
  { id: 'chicago',    lat: 41.9,   lng: -87.6,   label: 'Chicago',       showLabel: true,  labelSide: 'left'  },
  { id: 'sf',         lat: 37.8,   lng: -122.4,  label: 'San Francisco', showLabel: true,  labelSide: 'left'  },
  { id: 'toronto',    lat: 43.7,   lng: -79.4,   label: 'Toronto',       showLabel: true,  labelSide: 'left'  },
  { id: 'dubai',      lat: 25.2,   lng: 55.3,    label: 'Dubai',         showLabel: true,  labelSide: 'right' },
  { id: 'mumbai',     lat: 19.1,   lng: 72.9,    label: 'Mumbai',        showLabel: true,  labelSide: 'right' },
  { id: 'bangalore',  lat: 13.0,   lng: 77.6,    label: 'Bangalore',     showLabel: true,  labelSide: 'right' },
  { id: 'singapore',  lat: 1.4,    lng: 103.8,   label: 'Singapore',     showLabel: true,  labelSide: 'right' },
  { id: 'hongkong',   lat: 22.3,   lng: 114.2,   label: 'Hong Kong',     showLabel: true,  labelSide: 'right' },
  { id: 'tokyo',      lat: 35.7,   lng: 139.7,   label: 'Tokyo',         showLabel: true,  labelSide: 'right' },
  { id: 'sydney',     lat: -33.9,  lng: 151.2,   label: 'Sydney',        showLabel: true,  labelSide: 'right' },
  { id: 'auckland',   lat: -36.9,  lng: 174.8,   label: 'Auckland',      showLabel: true,  labelSide: 'right' },
];

const ARCS = [
  ['london','nyc'],['london','paris'],['london','frankfurt'],
  ['london','dubai'],['london','singapore'],['london','tokyo'],
  ['london','amsterdam'],['london','zurich'],['london','dublin'],
  ['paris','madrid'],['paris','milan'],['frankfurt','warsaw'],
  ['frankfurt','munich'],['zurich','geneva'],['munich','milan'],
  ['amsterdam','stockholm'],['warsaw','kyiv'],['barcelona','madrid'],
  ['manchester','dublin'],['nyc','boston'],['nyc','chicago'],
  ['nyc','toronto'],['nyc','sf'],['sf','tokyo'],['sf','chicago'],
  ['dubai','mumbai'],['mumbai','bangalore'],['singapore','hongkong'],
  ['hongkong','tokyo'],['singapore','sydney'],['sydney','auckland'],
  ['nyc','sydney'],['london','hongkong'],
];

function toXYZ(lat, lng) {
  const phi = (90 - lat) * Math.PI / 180;
  const th  = (lng + 180) * Math.PI / 180;
  return [-Math.sin(phi)*Math.cos(th), Math.cos(phi), Math.sin(phi)*Math.sin(th)];
}

function rot([x, y, z], ry, rx) {
  const x1 =  x*Math.cos(ry) + z*Math.sin(ry);
  const z1 = -x*Math.sin(ry) + z*Math.cos(ry);
  const y2 =  y*Math.cos(rx) - z1*Math.sin(rx);
  const z2 =  y*Math.sin(rx) + z1*Math.cos(rx);
  return [x1, y2, z2];
}

function slerp(a, b, t) {
  const d = Math.max(-1, Math.min(1, a[0]*b[0]+a[1]*b[1]+a[2]*b[2]));
  const om = Math.acos(d);
  if (Math.abs(om) < 0.001) return [a[0]+(b[0]-a[0])*t, a[1]+(b[1]-a[1])*t, a[2]+(b[2]-a[2])*t];
  const s = Math.sin(om);
  return [(Math.sin((1-t)*om)/s)*a[0]+(Math.sin(t*om)/s)*b[0],
          (Math.sin((1-t)*om)/s)*a[1]+(Math.sin(t*om)/s)*b[1],
          (Math.sin((1-t)*om)/s)*a[2]+(Math.sin(t*om)/s)*b[2]];
}

function arcPt(a, b, t, lift = 0.24) {
  const p = slerp(a, b, t), m = Math.sqrt(p[0]**2+p[1]**2+p[2]**2);
  const lf = 1 + lift * Math.sin(t * Math.PI);
  return [p[0]/m*lf, p[1]/m*lf, p[2]/m*lf];
}

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x+r, y); ctx.lineTo(x+w-r, y); ctx.quadraticCurveTo(x+w, y, x+w, y+r);
  ctx.lineTo(x+w, y+h-r); ctx.quadraticCurveTo(x+w, y+h, x+w-r, y+h);
  ctx.lineTo(x+r, y+h); ctx.quadraticCurveTo(x, y+h, x, y+h-r);
  ctx.lineTo(x, y+r); ctx.quadraticCurveTo(x, y, x+r, y);
  ctx.closePath();
}

export default function GlobeSection() {
  const canvasRef = useRef(null);
  const stateRef  = useRef({ ry: 0.5, rx: 0.18, drag: false, lx: 0, ly: 0, prog: 0 });

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let raf, logW = 0;

    const cityXYZ = Object.fromEntries(CITIES.map(c => [c.id, toXYZ(c.lat, c.lng)]));
    const landXYZ = LAND_DOTS.map(([la, ln]) => toXYZ(la, ln));

    function resize() {
      const parent = canvas.parentElement;
      logW = Math.min(parent.clientWidth, 700);
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width  = logW * dpr;
      canvas.height = logW * dpr;
      canvas.style.width  = logW + 'px';
      canvas.style.height = logW + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function draw() {
      const { ry, rx } = stateRef.current;
      const W = logW, H = logW;
      const cx = W/2, cy = H/2, R = W * 0.40;

      ctx.clearRect(0, 0, W, H);

      // Sphere
      const sgrd = ctx.createRadialGradient(cx-R*0.2, cy-R*0.2, R*0.05, cx, cy, R);
      sgrd.addColorStop(0, '#ffffff');
      sgrd.addColorStop(0.7, '#f5f5f5');
      sgrd.addColorStop(1, '#e8e8e8');
      ctx.fillStyle = sgrd;
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI*2); ctx.fill();

      ctx.shadowColor = 'rgba(0,0,0,0.10)';
      ctx.shadowBlur  = 28;
      ctx.strokeStyle = 'rgba(200,200,200,0.5)';
      ctx.lineWidth   = 1;
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI*2); ctx.stroke();
      ctx.shadowBlur  = 0;

      // Clip
      ctx.save();
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI*2); ctx.clip();

      // Land dots
      landXYZ.forEach((xyz) => {
        const [px, py, pz] = rot(xyz, ry, rx);
        if (pz < 0.02) return;
        const al = Math.min(1, (pz-0.02)/0.6) * 0.55;
        ctx.fillStyle = `rgba(160,160,160,${al})`;
        ctx.beginPath(); ctx.arc(cx+px*R, cy-py*R, 2.2, 0, Math.PI*2); ctx.fill();
      });

      ctx.restore();

      // Arcs — orange
      const N = 80, SEG = 0.26;
      stateRef.current.prog = (stateRef.current.prog + 0.0016) % 1;

      ARCS.forEach(([fid, tid], idx) => {
        const a = cityXYZ[fid], b = cityXYZ[tid];
        if (!a || !b) return;

        // Faint static arc
        ctx.lineWidth = 0.7;
        ctx.beginPath(); let go = false;
        for (let i = 0; i <= N; i++) {
          const [px, py, pz] = rot(arcPt(a, b, i/N), ry, rx);
          if (pz > 0) {
            ctx.strokeStyle = `rgba(78,108,126,${0.15 * pz})`;
            if (!go) { ctx.moveTo(cx+px*R, cy-py*R); go=true; }
            else ctx.lineTo(cx+px*R, cy-py*R);
          } else { if (go) ctx.stroke(); ctx.beginPath(); go=false; }
        }
        ctx.stroke();

        // Traveling segment — bright orange
        const phase = (idx * 0.618033) % 1;
        const segS  = (stateRef.current.prog + phase) % 1;
        const segE  = (segS + SEG) % 1;
        const ranges = segE > segS ? [[segS, segE]] : [[segS, 1],[0, segE]];

        ranges.forEach(([s, e]) => {
          if (e <= s) return;
          const steps = Math.max(2, Math.ceil((e-s)*N));
          const pts = [];
          for (let i = 0; i <= steps; i++) {
            const t  = s + (i/steps)*(e-s);
            const rp = rot(arcPt(a, b, t), ry, rx);
            pts.push({ rp, br: Math.sin((i/steps)*Math.PI) });
          }
          for (let i = 0; i < pts.length-1; i++) {
            const { rp:[px1,py1,pz1], br } = pts[i];
            const { rp:[px2,py2,pz2] }     = pts[i+1];
            if (pz1 < 0 || pz2 < 0) continue;
            ctx.beginPath();
            ctx.moveTo(cx+px1*R, cy-py1*R);
            ctx.lineTo(cx+px2*R, cy-py2*R);
            ctx.strokeStyle = `rgba(78,108,126,${0.6 + 0.4*br})`;
            ctx.lineWidth = 1.2 + br * 0.9;
            ctx.stroke();
          }
        });
      });

      // City dots + labels
      CITIES.forEach(({ id, label, showLabel, labelSide }) => {
        const [px, py, pz] = rot(cityXYZ[id], ry, rx);
        if (pz < 0.05) return;
        const sx = cx+px*R, sy = cy-py*R;
        const al = Math.min(1, (pz-0.05)/0.8);

        // Glow
        const g = ctx.createRadialGradient(sx, sy, 0, sx, sy, 8);
        g.addColorStop(0, `rgba(78,108,126,${al*0.3})`);
        g.addColorStop(1, 'rgba(78,108,126,0)');
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(sx, sy, 8, 0, Math.PI*2); ctx.fill();

        // Dot — orange
        ctx.fillStyle = `rgba(180,75,30,${al})`;
        ctx.beginPath(); ctx.arc(sx, sy, 3, 0, Math.PI*2); ctx.fill();
        ctx.fillStyle = `rgba(255,255,255,${al})`;
        ctx.beginPath(); ctx.arc(sx, sy, 1.2, 0, Math.PI*2); ctx.fill();

        // Label pill
        if (!showLabel || al < 0.45) return;
        const pad = 5, fs = 10;
        ctx.font = `600 ${fs}px monospace`;
        const tw  = ctx.measureText(label.toUpperCase()).width;
        const bw  = tw + pad*2, bh = 18;

        // Position: left side or right side of dot
        const bx = labelSide === 'left' ? sx - bw - 10 : sx + 10;
        const by = sy - bh/2;

        ctx.fillStyle = `rgba(15,15,30,${al * 0.92})`;
        roundRect(ctx, bx, by, bw, bh, 3);
        ctx.fill();

        ctx.fillStyle = `rgba(255,255,255,${al})`;
        ctx.fillText(label.toUpperCase(), bx+pad, by+bh/2+fs*0.35);

        // Triangle pointer
        ctx.fillStyle = `rgba(15,15,30,${al*0.92})`;
        ctx.beginPath();
        if (labelSide === 'left') {
          ctx.moveTo(bx+bw, by+bh/2-3);
          ctx.lineTo(bx+bw+5, by+bh/2);
          ctx.lineTo(bx+bw, by+bh/2+3);
        } else {
          ctx.moveTo(bx, by+bh/2-3);
          ctx.lineTo(bx-5, by+bh/2);
          ctx.lineTo(bx, by+bh/2+3);
        }
        ctx.closePath(); ctx.fill();
      });

      if (!stateRef.current.drag) stateRef.current.ry += 0.0022;
      raf = requestAnimationFrame(draw);
    }

    resize();
    const ro = new ResizeObserver(resize);
    ro.observe(canvas.parentElement);
    draw();

    const onDown = (e) => { stateRef.current.drag=true; stateRef.current.lx=e.clientX; stateRef.current.ly=e.clientY; canvas.style.cursor='grabbing'; };
    const onMove = (e) => {
      if (!stateRef.current.drag) return;
      stateRef.current.ry += (e.clientX-stateRef.current.lx)*0.006;
      stateRef.current.rx += (e.clientY-stateRef.current.ly)*0.004;
      stateRef.current.rx  = Math.max(-0.5, Math.min(0.5, stateRef.current.rx));
      stateRef.current.lx  = e.clientX; stateRef.current.ly = e.clientY;
    };
    const onUp = () => { stateRef.current.drag=false; canvas.style.cursor='grab'; };

    canvas.addEventListener('pointerdown', onDown);
    window.addEventListener('pointermove', onMove, { passive: true });
    window.addEventListener('pointerup',   onUp,   { passive: true });

    return () => {
      cancelAnimationFrame(raf); ro.disconnect();
      canvas.removeEventListener('pointerdown', onDown);
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup',   onUp);
    };
  }, []);

  return (
    <section id="cities" style={{ background: '#ffffff', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '80px 24px 60px', overflow: 'hidden' }}>
      <h2 style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: 'clamp(28px,4vw,48px)', fontWeight: 500, letterSpacing: '-0.03em', lineHeight: 1.15, color: '#0B1220', textAlign: 'center', marginBottom: 48 }}>
        Find an internship<br />
        <span style={{ background: 'linear-gradient(90deg,#4E6C7E,#3A5468)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>in your city.</span>
      </h2>
      <div style={{ width: '100%', maxWidth: 680 }}>
        <canvas ref={canvasRef} style={{ cursor: 'grab', display: 'block', touchAction: 'none', width: '100%' }} />
      </div>
    </section>
  );
}
